//var crDebug = true;
document.addEventListener('crJQActivated', function (e) {
  //console.log('-----------------------------------')
  setTimeout(function(){storePickup.changePickupButtonText();  }, 1000)
  
})
